import { createContext } from 'react'

export type contextType = {
    isOpen: boolean
    setOpen: (flag: boolean) => void
}

export const Context = createContext<contextType>({ isOpen: false, setOpen: () => {} })
